import { FallbackProps } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as WarningIcon } from 'assets/icons/Warning.svg';
import { Button, ButtonColor } from 'shared';

import RootModalLayout from '../RootModalLayout';

import styles from './AppCrushModal.module.scss';

const AppCrushModal = ({ resetErrorBoundary }: FallbackProps) => {
  const navigate = useNavigate();

  const handleNavigateMain = () => {
    resetErrorBoundary();
    navigate('/');
  };

  return (
    <RootModalLayout size='medium' includeHeader={false} className={styles.layout}>
      <div className={styles.container}>
        <div className={styles.head}>
          <WarningIcon />
          <h1>Warning</h1>
        </div>
        <span className={styles.text}>This service is temporarily unavailable.</span>
        <div className={styles.actions}>
          <Button className={styles.closeButton} color={ButtonColor.SECONDARY} onClick={handleNavigateMain}>
            Close
          </Button>
          <Button color={ButtonColor.SECONDARY} onClick={handleNavigateMain}>
            Back to Dashboard
          </Button>
        </div>
      </div>
    </RootModalLayout>
  );
};

export default AppCrushModal;
